import {
  CLEAR_PURCHASES,
  PURCHASE_PRODUCTS_RESPONSE,
  PURCHASE_REQUEST,
  PURCHASE_RESPONSE,
} from '../actions/purchase.actions';

export default function purchase(state = {products: {}, purchases: {}}, action) {
  switch (action.type) {
    case PURCHASE_PRODUCTS_RESPONSE: {
      let nextState = {...state};
      nextState.products = action.products;
      return nextState;
    }
    case CLEAR_PURCHASES: {
      let nextState = {...state};
      nextState.purchases = {};
      return nextState;
    }

    case PURCHASE_REQUEST: {
      let nextState = {...state};
      nextState.purchases = {};
      return nextState;
    }
    case PURCHASE_RESPONSE: {
      let nextState = {...state};
      action.purchases.map(purchase => (nextState.purchases[purchase.productEntitlementId] = purchase));
      return nextState;
    }
  }
  return state;
}
